import { call } from 'redux-saga/effects';

import { getDataRoleInfos } from '~src/app/sagas/spaces/SpacesSagaHelpers';
import { DataRoleCard } from '~src/app/spaces/CardView/DataRoleCard';
import { SpacesSiteUrls } from '~src/app/spaces/SpacesSiteUrls';
import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/common/utilities/ImgUrl';
import { ContentTypeFilterClause,MixedContentItemDefinition, SpaceDefinition } from '~src/contentDefinitionInterfaces/ContentDefinitionsTypes';
import { ServerFilterClauses } from '~src/ts/helpers/ServerFilterClauses';
import { DataRoleContentType } from '~src/ts/models/ContentTypes';
import { IContentInfo } from '~src/ts/models/IContentInfo';
import { DataRoles } from '~src/ts/resources/Dataroles';

import { getGenericDefaultFilters } from './getDefaultFilters';

export const DataRoleDefinition: MixedContentItemDefinition & SpaceDefinition<'dataRole'> = {
  itemType: 'dataRole',
  contentType: 'dataRole',
  singularName: Messages.dataRole,
  pluralName: Messages.dataRoles,
  emptyStateMessage: Messages.dataRolesEmptyMessage,
  siteFilterByTypeDropdownName: Messages.siteFilterByTypeDropdown_Dataroles,
  contentFilterKeys: DataRoleContentType.filterKeys,
  defaultFilters: getGenericDefaultFilters,
  cardComponent: DataRoleCard,
  listViewIconUrl: imgPath('datasource_role_18px-large.svg'),
  filterClause: ServerFilterClauses.ContentType(['dataRole']) as ContentTypeFilterClause,
  contentSpaceUrl: (urls: SpacesSiteUrls, contentId: string) => urls.dataRoleUrl(contentId),
  getBasicQuery: () => {
    return DataRoles.all().withExtraParams(DataRoleContentType.extraQueryParams);
  },
  fieldValueResourceType: 'dataRole',
  getContentInfo: (contentList: IContentInfo[]) => call(getDataRoleInfos, contentList),
  supportedDisplayModes: ['list', 'thumbnail'],
  headerIconPath: () => imgPath('spaces_masthead_datarole.svg'),
};
